/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SearchVoid = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.82446 1.33012C14.3938 1.33039 18.0979 5.03509 18.0979 9.60453C18.0977 11.6188 17.3764 13.4638 16.1799 14.8985L18.6711 17.3887C18.9638 17.6815 18.9636 18.1574 18.6711 18.4502C18.3783 18.7431 17.9025 18.743 17.6096 18.4502L15.1194 15.959C13.6845 17.1559 11.8391 17.8779 9.82446 17.878C5.25514 17.878 1.55051 14.1737 1.55005 9.60453C1.55005 5.03493 5.25486 1.33012 9.82446 1.33012ZM9.82446 2.83012C6.08329 2.83012 3.05005 5.86336 3.05005 9.60453C3.05051 13.3453 6.08357 16.378 9.82446 16.378C13.5651 16.3777 16.5974 13.3452 16.5979 9.60453C16.5979 5.86352 13.5654 2.83039 9.82446 2.83012Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default SearchVoid;
